<template>
  <div class="siteProfile">
    <div class="panelheader">
      <div class="title">Information</div>
    </div>
    <div class="panel">
      <div class="site_info site_name">{{site.name}}</div>
      <div class="site_info site_address">{{site.address}}</div>
      <div class="site_info site_contact"><icon name="user"></icon> {{site.contact_name}}</div>
      <div class="site_info site_contact"><icon name="envelope"></icon>{{site.contact_email}}</div>
      <div class="site_info site_contact phone"><icon name="phone"></icon> {{site.contact_phone}}</div>
    </div>
  </div>
</template>

<script>
  import auth from '../auth'
  import { formatTime, getHourTime, formatTimeStr } from '../javascript/helpers'
  import 'vue-awesome/icons/user'
  import 'vue-awesome/icons/envelope'
  import 'vue-awesome/icons/phone'
  import Icon from 'vue-awesome/components/Icon'

  export default {
    name:'siteProfile',
    data(){
      return {
        site:{
          name:'',
          address:'',
          contact_name:'',
          contact_email:'',
          contact_phone:''
        },
      }
    },
    beforeMount(){
      var header = {headers: auth.getAuthHeader()};
      var uri = auth.getApi();
      
      this.$http.get(uri + '/api/site/' + this.$route.params.id,{headers:{'x-access-token':header['headers']['x-access-token']}}).then(result=>{
        var site = result.body.data;

        //var t = formatTimeStr(site.auto_off_time);
        //this.lights.off = formatTime(t.h, t.m) + getHourTime(t.h);


        this.site.name = site.name;
        this.site.address = site.address;
        this.site.contact_name = site.contact_name;
        this.site.contact_email = site.contact_email;
        this.site.contact_phone = site.contact_phone;
      });
    },
    components:{
      Icon
    }
  }
</script>


// WEBPACK FOOTER //
// SiteProfile.vue?9a278c42